
import React, {useEffect, useState} from "react";
import API, {ROUTES} from "../../../commons/api/api";
import QnaPageComponent from "./../components/index"

const QnaPageContainer  = () => {

    const [qnaData, setQnaData] = useState([])
    const [loadMore, setloadMore] = useState(false)
    const [loading, setLoading] = useState(true)
    const [qnaCategories, setQnaCategories] = useState([])

    const fetchDataCategoriesQna = async (param = '?per_page=0') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_QNA_CATEGORIES+param);
            setQnaCategories(response?.data);
        } catch (error) {
            console.error(error.message);
        }
    }

    const fetchData = async (param = '') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_QNA+param);
            setQnaData(response?.data);
            setLoading(false)
            if(response?.data?.current_page == response?.data?.last_page) {
                setloadMore(false)
            }else {
                setloadMore(true)
            }
        } catch (error) {
            console.error(error.message);
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData();
        // fetchDataCategoriesQna();
    }, []);

    const loadMoreData = () => {
        setloadMore(false)
    }

    return <QnaPageComponent qnaData={qnaData} qnaCategories={qnaCategories} fetchData={fetchData} loading={loading} />;
};

export default QnaPageContainer ;